import React from 'react';

const HeroSimple = () => {
  return (
    <section style={{
      background: 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 50%, #3730a3 100%)',
      color: 'white',
      padding: '4rem 0 6rem 0',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Header with Beno - Desktop only */}
      <div style={{
        position: 'absolute',
        top: '2rem',
        left: '2rem',
        fontSize: '1.5rem',
        fontWeight: 'bold',
        color: 'white',
        display: 'none'
      }}
        className="desktop-only"
      >
        Beno
      </div>


      <div className="container" style={{ textAlign: 'center', position: 'relative', zIndex: 1 }}>
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          {/* Mobile Beno logo */}
          <div style={{
            fontSize: '2rem',
            fontWeight: 'bold',
            color: 'white',
            marginBottom: '1.5rem'
          }}
            className="mobile-only"
          >
            Beno
          </div>

          {/* Centered tagline box */}
          <div style={{
            background: 'rgba(255, 255, 255, 0.1)',
            borderRadius: '1rem',
            padding: '0.75rem 1.5rem',
            marginBottom: '2rem',
            backdropFilter: 'blur(10px)',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.5rem',
            fontSize: '0.875rem',
            color: 'rgba(255, 255, 255, 0.9)',
            fontWeight: '500'
          }}>
            <span>✨</span>
            <span>Especialistas em sites para profissionais da saúde</span>
          </div>

          <h1 style={{
            fontSize: 'clamp(2.5rem, 6vw, 4rem)',
            fontWeight: 'bold',
            marginBottom: '1.5rem',
            lineHeight: '1.1'
          }}>
            Site profissional da saúde que aparece no{' '}
            <span style={{ color: '#fbbf24' }}>Google e ChatGPT</span>
          </h1>

          <p style={{
            fontSize: '1.25rem',
            marginBottom: '2rem',
            color: 'rgba(255, 255, 255, 0.9)'
          }}>
            Beno cria seu site em 5 minutos.
          </p>

          {/* Professional categories - in a styled box */}
          <div style={{
            background: 'rgba(255, 255, 255, 0.1)',
            borderRadius: '1rem',
            padding: '1.5rem',
            marginBottom: '3rem',
            backdropFilter: 'blur(10px)',
            border: '1px solid rgba(255, 255, 255, 0.2)'
          }}>
            <div style={{
              fontSize: '1rem',
              marginBottom: '1rem',
              color: 'rgba(255, 255, 255, 0.9)',
              fontWeight: '500'
            }}>
              Para profissionais da saúde
            </div>
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              gap: '1.5rem',
              flexWrap: 'wrap',
              fontSize: '1rem',
              marginBottom: '1.5rem'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <span>🩺</span>
                <span>Médicos</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <span>🦷</span>
                <span>Dentistas</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <span>🧠</span>
                <span>Psicólogos</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <span>🥗</span>
                <span>Nutricionistas</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <span>🏃</span>
                <span>Fisioterapeutas</span>
              </div>
            </div>
            
            {/* Stats inside the box */}
            <div style={{
              fontSize: '0.875rem',
              color: 'rgba(255, 255, 255, 0.8)',
              textAlign: 'center'
            }}>
              ✨ +2.847 profissionais já aparecem no Google e ChatGPT
            </div>
          </div>

          {/* CTA Button */}
          <button
            style={{
              background: '#fbbf24',
              color: '#1f2937',
              fontWeight: 'bold',
              padding: '1rem 2.5rem',
              borderRadius: '0.75rem',
              border: 'none',
              cursor: 'pointer',
              fontSize: '1.125rem',
              boxShadow: '0 4px 15px rgba(251, 191, 36, 0.3)',
              transition: 'all 0.3s ease'
            }}
            onClick={() => {
              const searchSection = document.querySelector('.search-section');
              if (searchSection) {
                searchSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
            }}
            onMouseEnter={(e) => {
              (e.target as HTMLButtonElement).style.transform = 'translateY(-2px)';
              (e.target as HTMLButtonElement).style.boxShadow = '0 6px 20px rgba(251, 191, 36, 0.4)';
            }}
            onMouseLeave={(e) => {
              (e.target as HTMLButtonElement).style.transform = 'translateY(0)';
              (e.target as HTMLButtonElement).style.boxShadow = '0 4px 15px rgba(251, 191, 36, 0.3)';
            }}
          >
            Teste grátis por 7 dias — Sem compromisso →
          </button>

        </div>
      </div>

      {/* CSS for mobile/desktop visibility */}
      <style>{`
        @media (min-width: 768px) {
          .desktop-only {
            display: block !important;
          }
          .mobile-only {
            display: none !important;
          }
        }
        @media (max-width: 767px) {
          .desktop-only {
            display: none !important;
          }
          .mobile-only {
            display: block !important;
          }
        }
      `}</style>
    </section>
  );
};

export default HeroSimple;